export default __webpack_public_path__ + "static/gcn-responsive-animation-poster-25e764510a2ab16501646c2cbad26646.png";